import { render, staticRenderFns } from "./MonthlySocsoMaybank.vue?vue&type=template&id=2b06631d&scoped=true"
import script from "./MonthlySocsoMaybank.vue?vue&type=script&lang=js"
export * from "./MonthlySocsoMaybank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b06631d",
  null
  
)

export default component.exports